import { SUPPORTED_LANGUAGES, type LanguageCode } from "../constants/languages";

export function normalizeLang(lang?: string | null): LanguageCode {
  const defaultLang: LanguageCode = "es";
  
  if (!lang) return defaultLang;

  // Extraemos la primera parte ("es-ES" -> "es", "en_US" -> "en")
  const shortCode = lang.trim().toLowerCase().split(/[-_]/)[0];

  // Comprobamos si existe en nuestro nuevo mapa corto
  const isSupported = shortCode in SUPPORTED_LANGUAGES;

  return isSupported ? (shortCode as LanguageCode) : defaultLang;
}